import { r as registerInstance, h } from './index-5faac9d7.js';

const pesPresentationTabCss = ".se-container-wide{max-width:1200px;margin-left:auto;margin-right:auto;padding-left:15px;padding-right:15px}@media screen and (min-width: 980px){.se-container-wide{padding-left:10px;padding-right:10px}}ul{padding:0 0 12px}ul li{list-style:disc inside;text-indent:0;margin-bottom:15px;color:#626469;font-family:ArialRoundedMTforSE_Latin, Arial, \"Helvetica Neue\", Helvetica, sans-serif;font-display:swap;font-size:13px;font-weight:400;line-height:19.5px}p{color:#626469;font-family:ArialRoundedMTforSE_Latin, Arial, \"Helvetica Neue\", Helvetica, sans-serif;font-display:swap;font-size:13px;font-weight:400;line-height:19.5px}.pes-presentation-tab{display:flex;margin:0 auto;padding-top:20px}@media screen and (min-width: 980px){.pes-presentation-tab{padding-left:0;padding-right:0}}.pes-presentation-tab strong{line-height:34px}.pes-presentation-tab table{width:100%}.pes-presentation-tab .more-features-content{margin-top:20px}.pes-presentation-tab .list-images{display:flex;flex-wrap:wrap;justify-content:space-between}@media screen and (min-width: 980px){.pes-presentation-tab .list-images{justify-content:start}}.pes-presentation-tab .list-images__image{width:100%}.pes-presentation-tab .list-images__image-wrapper{max-width:calc(50% - 20px);list-style:none;display:list-item;flex-direction:column;margin:0;padding:0;border-bottom:40px solid transparent}@media screen and (min-width: 980px){.pes-presentation-tab .list-images__image-wrapper{width:196px;justify-content:start;border-bottom:40px solid transparent;border-left:20px solid transparent;border-right:20px solid transparent}}.article+.article{border-top:solid 1px #e6e6e6;margin-top:27px}.article__header,.article h3{font-size:40px;color:#3dcd58;line-height:1.5em;margin:14px 0;font-weight:400;text-align:center}@media screen and (min-width: 980px){:host(:not([dir=\"rtl\"])) .article__header,:host(:not([dir=\"rtl\"])) .article h3{text-align:left}:host([dir=\"rtl\"]) .article__header,:host([dir=\"rtl\"]) .article h3{text-align:right}}.article iframe{max-width:100%}";

const PesPresentationTab = class {
  constructor(hostRef) {
    registerInstance(this, hostRef);
    this.presentation = undefined;
  }
  renderMoreFeatures() {
    var _a, _b;
    if ((_a = this.presentation) === null || _a === void 0 ? void 0 : _a.presentation2) {
      return h("div", { class: "more-features-content", innerHTML: (_b = this.presentation) === null || _b === void 0 ? void 0 : _b.presentation2 });
    }
  }
  renderArticle({ label, content = '', extraLayout = '' }) {
    if (label && (content || extraLayout)) {
      return (h("article", { class: "article" }, h("h3", { class: "article__header" }, label), content && h("div", { class: "article__content", innerHTML: content }), extraLayout));
    }
  }
  renderBenefits() {
    var _a, _b, _c;
    if ((_a = this.presentation) === null || _a === void 0 ? void 0 : _a.benefits) {
      return this.renderArticle({
        label: (_b = this.presentation) === null || _b === void 0 ? void 0 : _b.rangePresentationBenefitsLabel,
        content: (_c = this.presentation) === null || _c === void 0 ? void 0 : _c.benefits,
      });
    }
  }
  renderFeatures() {
    var _a, _b, _c, _d;
    if (((_a = this.presentation) === null || _a === void 0 ? void 0 : _a.presentation1) || ((_b = this.presentation) === null || _b === void 0 ? void 0 : _b.presentation2)) {
      return this.renderArticle({
        label: (_c = this.presentation) === null || _c === void 0 ? void 0 : _c.rangePresentationFeaturesLabel,
        content: (_d = this.presentation) === null || _d === void 0 ? void 0 : _d.presentation1,
        extraLayout: this.renderMoreFeatures(),
      });
    }
  }
  renderApplications() {
    var _a, _b, _c;
    if ((_a = this.presentation) === null || _a === void 0 ? void 0 : _a.rangeApplication) {
      return this.renderArticle({
        label: (_b = this.presentation) === null || _b === void 0 ? void 0 : _b.rangePresentationApplicationsLabel,
        content: (_c = this.presentation) === null || _c === void 0 ? void 0 : _c.rangeApplication,
      });
    }
  }
  renderGallery() {
    var _a, _b, _c, _d;
    if (((_a = this.presentation) === null || _a === void 0 ? void 0 : _a.images) && ((_b = this.presentation) === null || _b === void 0 ? void 0 : _b.images.length)) {
      const extraLayout = (h("ul", { class: "list-images" }, (_c = this.presentation) === null || _c === void 0 ? void 0 : _c.images.map((i) => (h("li", { class: "list-images__image-wrapper" }, h("img", { class: "list-images__image", src: i.url, alt: i.title }))))));
      return this.renderArticle({ label: (_d = this.presentation) === null || _d === void 0 ? void 0 : _d.rangeGaleryLabel, extraLayout });
    }
  }
  render() {
    return (h("div", { class: "pes-presentation-tab" }, h("div", null, this.renderFeatures(), this.renderBenefits(), this.renderApplications(), this.renderGallery())));
  }
};
PesPresentationTab.style = pesPresentationTabCss;

export { PesPresentationTab as pes_presentation_tab };
